import Analytics from '@/components/analytics';
import ClientReload from '@/components/ClientReload';
import LayoutWrapper from '@/components/LayoutWrapper';
import '@/css/gradient.css';
import '@/css/home.css';
import '@/css/prism.css';
import '@/css/tailwind.css';
import siteMetadata from '@/data/siteMetadata';
import { ThemeProvider } from 'next-themes';
import Head from 'next/head';
import { RestfulProvider } from 'restful-react';

const isDevelopment = process.env.NODE_ENV === 'development';
const isSocket = process.env.SOCKET;

export default function App({ Component, pageProps }) {
  return (
    <ThemeProvider attribute="class" defaultTheme={siteMetadata.theme}>
      <RestfulProvider base="">
        <Head>
          <meta content="width=device-width, initial-scale=1" name="viewport" />
        </Head>
        {isDevelopment && isSocket && <ClientReload />}
        <Analytics />
        <LayoutWrapper>
          <Component {...pageProps} />
        </LayoutWrapper>
      </RestfulProvider>
    </ThemeProvider>
  );
}
